import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/Play.svg'

export const IconPlay = IconSVG as IconComponent
